import { create } from 'zustand';

import { ApiDocumentResponseV2 } from '@/shared/api';

type DocumentsStoreState = {
  documents: ApiDocumentResponseV2[];
  isLoading: boolean;
  isInitialized: boolean;
};

type DocumentsStore = DocumentsStoreState & {
  setDocuments: (documents: ApiDocumentResponseV2[]) => void;
  addDocument: (newDocument: ApiDocumentResponseV2) => void;
  updateDocument: (documentId: string, updates: Omit<Partial<ApiDocumentResponseV2>, 'id'>) => void;
  removeDocument: (documentId: string) => void;
  setLoading: (isLoading: boolean) => void;
  setInitialized: (isInitialized: boolean) => void;
  clear: () => void;
};

export const useDocumentsStore = create<DocumentsStore>((set) => ({
  documents: [],
  isLoading: false,
  isInitialized: false,

  setDocuments: (documents) => set({ documents }),
  addDocument: (newDocument) =>
    set((state) => {
      const existingIndex = state.documents.findIndex((d) => d.id === newDocument.id);
      if (existingIndex !== -1) {
        const updatedDocuments = [...state.documents];
        updatedDocuments[existingIndex] = newDocument;
        return { documents: updatedDocuments };
      }
      return { documents: [newDocument, ...state.documents] };
    }),
  updateDocument: (documentId, data) =>
    set((state) => ({
      documents: state.documents.map((d) => (d.id === documentId ? { ...d, ...data } : d)),
    })),
  removeDocument: (documentId) =>
    set((state) => ({
      documents: state.documents.filter((d) => d.id !== documentId),
    })),
  setLoading: (isLoading) => set({ isLoading }),
  setInitialized: (isInitialized) => set({ isInitialized }),
  clear: () => set({ documents: [], isInitialized: false }),
}));
